<div class="modal-header">
  <h5 class="modal-title" i18n="@@TechnicalChargingStationsActions">Aktionen</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>
<div class="modal-body">
  <p class="text-muted mb-3" *ngIf="station">{{ station.name }}</p>
  <div class="d-flex flex-column gap-2">
      <button type="button" class="btn btn-outline-warning"
        [disabled]="loadingAction !== null"
        (click)="runReset('SOFT')">
        <span *ngIf="loadingAction === 'reset-SOFT'" class="spinner-border spinner-border-sm me-1" role="status"></span>
        Neustart SOFT
      </button>
      <button type="button" class="btn btn-outline-warning"
        [disabled]="loadingAction !== null"
        (click)="runReset('HARD')">
        <span *ngIf="loadingAction === 'reset-HARD'" class="spinner-border spinner-border-sm me-1" role="status"></span>
        Neustart HARD
      </button>
      <button type="button" class="btn btn-outline-danger"
        [disabled]="loadingAction !== null"
        (click)="setAvailability(false)">
        <span *ngIf="loadingAction === 'lock'" class="spinner-border spinner-border-sm me-1" role="status"></span>
        Sperren
      </button>
      <button type="button" class="btn btn-outline-success"
        [disabled]="loadingAction !== null"
        (click)="setAvailability(true)">
        <span *ngIf="loadingAction === 'unlock'" class="spinner-border spinner-border-sm me-1" role="status"></span>
        Entsperren
      </button>
      <button type="button" class="btn btn-outline-primary"
        [disabled]="loadingAction !== null"
        (click)="toggleRoaming()">
        <span *ngIf="loadingAction === 'roaming'" class="spinner-border spinner-border-sm me-1" role="status"></span>
        {{ station?.isHubjectAvailable ? 'Roaming deaktivieren' : 'Roaming aktivieren' }}
      </button>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="cancel()" i18n="@@CancelButton">Abbrechen</button>
</div>
